import { createFileRoute, redirect } from '@tanstack/react-router';
import { readAuthToken } from '@noor/api';
import { env, FIRST_PAGE } from '@noor/config';
import { rbacSearchSchema, type RbacSearch } from '@/entities/rbac';
import { sessionQueries } from '@/entities/session';
import { RbacPage } from '@/pages/rbac';

export const Route = createFileRoute('/rbac')({
  staticData: { permission: 'rbac.view' },
  beforeLoad: () => {
    if (!env.VITE_ENABLE_MSW && !readAuthToken()) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }
  },
  validateSearch: rbacSearchSchema,
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(sessionQueries.me());
  },
  component: RbacRoute,
});
function RbacRoute() {
  const params = Route.useSearch();
  const navigate = Route.useNavigate();
  const onParamsChange = (next: Partial<RbacSearch>) => {
    void navigate({
      search: (previous) => ({
        ...previous,
        ...next,
        ...(!('page' in next) ? { page: FIRST_PAGE } : {}),
      }),
    });
  };
  return <RbacPage params={params} onParamsChange={onParamsChange} />;
}
